module.exports = __webpack_public_path__ + "static/media/nearshore-consulting.92973201.png";